import React, { useEffect, useState, useCallback } from 'react';
import DragAndDrop from './DnDProviderElement';
import { Card } from './Card';
import update from 'immutability-helper';

export enum FIELD_TYPES {
    STRING = 'string',
    IMAGE = 'image',
}

export interface Field<T, U> {
    key: string;
    type?: FIELD_TYPES;
    // TODO: Type the card data somehow
    modifier?: (data: T, cardData: any) => U;
}

export interface ICard {
    [key: string]: any;
}

export interface IDraggableListProps<T> {
    className: string;
    list: T[];
    id: string;
    fields: Field<any, any>[];
    /** Field index to use for naming each row's HTML element */
    nameFieldIndex: number;
    onClick?: (data: T) => void;
    onDrop?: (data: T[]) => void;
    dataComponentName?: string;
}

const DraggableList = (props: IDraggableListProps<ICard>) => {
    const { className, list, id, fields, onClick, onDrop, nameFieldIndex } = props;

    const [cards, setCards] = useState(list);
    useEffect(() => {
        setCards(list);
    }, [list]);

    const moveCard = useCallback(
        (dragIndex: number, hoverIndex: number) => {
            const dragCard = cards[dragIndex];
            setCards(
                update(cards, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, dragCard],
                    ],
                }),
            );
        },
        [cards],
    );

    const handleDrop = () => {
        if (onDrop) {
            onDrop(cards);
        }
    };
    const renderCard = (card: ICard, index: number) => {
        const key = card?.id || index;
        return (
            <Card
                key={key}
                index={index}
                card={card}
                id={key}
                name={card[fields[nameFieldIndex].key]}
                fields={fields}
                moveCard={moveCard}
                onClick={onClick}
                onDrop={handleDrop}
            />
        );
    };
    return (
        <DragAndDrop>
            <div key={id} className={`draggable ${className}`} data-component-name={props.dataComponentName}>
                {cards.map((card, index) => renderCard(card, index))}
            </div>
        </DragAndDrop>
    );
};

DraggableList.defaultProps = {
    className: '',
};

export default DraggableList;
